/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Controller for Maintenance Alert.
 */
angular.module('bulbApp.alertsModule')
  .controller('MaintenanceAlertController', [
    '$cookies', '$filter', 'BulbAjaxService', 'ALERT',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    MaintenanceAlertController,
  ]);

function MaintenanceAlertController($cookies, $filter, BulbAjaxService, ALERT) {
  const that = this;

  // Set or clear this.maintenanceBegins, depending on the cookie value.
  // Set this.translateValues to date and time arguments to be inserted into the Maintenance Alert message.
  // If this.maintenanceBegins is not set, set translateValues to an empty object.
  function checkCookie() {
    const cookie = $cookies.get(ALERT.MAINTENANCE.COOKIE_NAME);
    if (cookie) {
      const cookieValue = cookie.trim().replace(/"(.*)"/, '$1');
      if (cookieValue.indexOf(ALERT.MAINTENANCE.ACK_PATTERN) >= 0) {
        that.maintenanceBegins = null;
        that.translateValues = {};
      } else {
        that.maintenanceBegins = new Date(cookieValue);
        that.translateValues = {
          date: $filter('date')(that.maintenanceBegins, 'longDate'),
          time: $filter('date')(that.maintenanceBegins, 'shortTime'),
        };
      }
    } else {
      that.maintenanceBegins = null;
      that.translateValues = {};
    }
  }

  /**
   * Arrange to check the cookie on every response from the server.
   * @see https://github.com/mgonto/restangular#addresponseinterceptor
   */
  BulbAjaxService.addResponseInterceptor((data, operation, what, url, response, deferred) => {
    checkCookie();
    return data;
  });

  /**
   * Define close function: Mark the cookie acknowledged by adding the :ACK suffix to the cookie value.
   */
  this.close = function close() {
    const cookie = $cookies.get(ALERT.MAINTENANCE.COOKIE_NAME);
    if (cookie) {
      // remove quotes, append :ACK suffix
      const cookieValue = cookie.trim().replace(/"(.*)"/, '$1') + ALERT.MAINTENANCE.ACK_PATTERN;
      // save, as session cookie
      $cookies.put(ALERT.MAINTENANCE.COOKIE_NAME, cookieValue, {
        secure: true,
        samesite: 'None',
      });
    }
    // update this.maintenanceBegins
    checkCookie();
  };
}
